class FjProductGallery extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll('[data-gallery-image]');
    this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
    this.main = this.querySelector('.fj-product-gallery__main');
    this.currentIndex = 0;
    this.isBottleDrag = false;

    this.addEventListener('click', this.onClick.bind(this));

    if (this.main) {
      this.main.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.main.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
    }
  }

  onClick(event) {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    this.showImage(Number(thumb.dataset.index));
  }

  onTouchStart(event) {
    // Drags that start on the 3D bottle orbit the camera - they are not a
    // gallery swipe (same rule as fj-home-hero.js).
    this.isBottleDrag = Boolean(event.target.closest('[data-fj-bottle]'));
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event) {
    if (this.isBottleDrag) return;

    const touchEndX = event.changedTouches[0].screenX;
    const delta = touchEndX - this.touchStartX;
    const SWIPE_THRESHOLD = 40;

    if (Math.abs(delta) < SWIPE_THRESHOLD) return;

    if (delta < 0) {
      this.showImage(Math.min(this.currentIndex + 1, this.images.length - 1));
    } else {
      this.showImage(Math.max(this.currentIndex - 1, 0));
    }
  }

  showImage(index) {
    this.currentIndex = index;
    this.images.forEach((img, i) => {
      img.hidden = i !== index;
      img.classList.toggle('is-active', i === index);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
  }
}

customElements.define('fj-product-gallery', FjProductGallery);